import {Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FileInput, FileInputComponent, FileValidator} from "ngx-material-file-input";
import {ReplaySubject} from "rxjs";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Dictionary} from "../../../shared/interface/dictionary";
import {AddressImport} from "../../../shared/interface/address-import";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {AddressImportService} from "../../../shared/services/address-import.service";
import {MatDialogRef} from "@angular/material/dialog";
import {DOCUMENT} from "@angular/common";
import {delay, first, takeUntil} from "rxjs/operators";
import {Uuid} from "../../../shared/interface/response/uuid";
import {HttpErrorResponse} from "@angular/common/http";
import {ImportContactService} from "../../../shared/services/import-contact.service";
import {ImportContact} from "../../../shared/interface/import-contact";

@Component({
  selector: 'app-import-contact-add-import',
  templateUrl: './import-contact-add-import.component.html',
  styleUrls: ['./import-contact-add-import.component.scss']
})
export class ImportContactAddImportComponent implements OnInit, OnDestroy {

  @ViewChild('fileInput') fileInputComponent: FileInputComponent;

  importCompanyId: ReplaySubject<number> = new ReplaySubject<number>(1);
  importContractFormValid = false;
  importContractForm: FormGroup;
  fileControl: FormControl;

  typeKeys: string[] = [];
  fileMaxSize = 52428800;
  selectedTypes: Dictionary[] = [];
  processingRequest = false;
  formErrors = {};
  importContact?: ImportContact;
  structureControl: FormControl;
  typeControl: FormControl;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private formHelper: FormHelperService,
    private importContactService: ImportContactService,
    public dialogRef: MatDialogRef<ImportContactAddImportComponent>,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.importContractForm = fb.group({
      structure: this.structureControl =  fb.control('',  [Validators.required]),
      type: this.typeControl =  fb.control('',  [Validators.required]),
      fileContent: fb.control('', [Validators.required]),
      fileName: fb.control('', [Validators.required]),
      file: this.fileControl = fb.control('', [Validators.required, FileValidator.maxContentSize(this.fileMaxSize)]),
    });
  }

  ngOnInit(): void {
    this.importContractForm.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        delay(0)
      )
      .subscribe(() => {
        this.importContractFormValid = this.importContractForm.valid;
      });

    this.fileControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((file: FileInput) => {
        if (!file || file.files.length === 0) {
          this.importContractForm.get('fileContent').setValue('');
          this.importContractForm.get('fileName').setValue('');
          return;
        }
        file.files.forEach((fileToRead: File) => {
          const reader = new FileReader();
          reader.readAsDataURL(fileToRead);
          reader.onload = () => {
            this.importContractForm.get('fileName').setValue(fileToRead.name);
            this.importContractForm.get('fileContent').setValue(/base64,(.+)/.exec(reader.result.toString())[1]);
          };
        });
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }


  import(): void {
    if (!this.importContractForm.valid) {
      this.importContractForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }

    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.importContractForm, this.formErrors);
    this.formErrors = {};

    this.importContactService.import(this.importContractForm.value)
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snack.open('Rozpoczynanie importowania', '', {
          duration: 2000,
        });
        this.dialogRef.close();
        this.processingRequest = false;
        this.loadImport(response.uuid);
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snack.open('Podczas importu wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.importContractForm, this.formErrors);
        }
      })
    ;
  }

  resetFileValue(): void {
    this.fileControl.setValue('');
    this.fileInputComponent.clear();
  }
  cancel(e): void {
    this.dialogRef.close(e);
    return;
  }

  loadImport(importId: string): void {
    this.importContactService.getImport(importId)
      .pipe(delay(1000))
      .subscribe((importContact: ImportContact) => {
        this.importContact = importContact;

        if (importContact.progress !== 100) {
          this.loadImport(importContact.uuid);
        } else {
          this.snack.open('Import zakończony prawidłowo', '', {
            duration: 2000,
          });
        }
      });
  }
}
